<template>

	<li class="timeline-item">
		<i class="fa fa-circle"></i>
		<slot></slot>
	</li>

</template>
<script type="text/javascript">
export default {
	name: "TimeLineItem",
	props: []
}
</script>

<style type="text/css" scoped>

	.fa-circle {
		position: relative;
		left: -26px;
		font-size: 12px;
		color: #e0e0e0;
	}

	.timeline-item {
		border-left: 1px solid #e0e0e0;
		padding: 5px;
		padding-left: 20px;
	}
</style>